  /* testimonial slider */
var $ = jQuery; 

// horizontal scroll
if ( $(window).width() > 991 ) { 

    var controller = new ScrollMagic.Controller();
  
    var scrollHorizontal = new TimelineLite()
      scrollHorizontal.to("#what-we-do", 1, {x:'-50%'})
  
    var horizontalScroll = new ScrollMagic.Scene({
          triggerElement: "#what-we-do",
          triggerHook: 'onLeave',
          duration: 20000,
        }).setPin("#what-we-do").setTween(scrollHorizontal).addTo(controller);
}

  if ( $(window).width() > 1199 ) { 

    var controller2 = new ScrollMagic.Controller();
  
    var scrollHorizontal2 = new TimelineLite()
      scrollHorizontal2.to("#meet-ryan", 1, {x:'-50%'})
  
    var horizontalScroll2 = new ScrollMagic.Scene({
          triggerElement: "#meet-ryan",
          triggerHook: 'onLeave',
          duration: 3000
        }).setPin("#meet-ryan").setTween(scrollHorizontal2).addTo(controller2);
  
        
  
  }




  //intersection obeserver 


if ($(window).width() > 692 ) { 
document.addEventListener("DOMContentLoaded", ()=>{
	let options = {
		threshold: 0.1
	};

	let observer = new IntersectionObserver(navGreen,options);

	let target = document.querySelector('#carouselWhatWeDo');

	observer.observe(target);
});

function navGreen(entries, observer){

	entries.forEach(entry=> {

		if(entry.isIntersecting){
      document.querySelector('nav').classList.remove('transparent');
      document.querySelector('nav').classList.remove('white');
      document.querySelector('nav').classList.add('green');
      
    } else {
      document.querySelector('nav').classList.remove('green');
      document.querySelector('nav').classList.add('white');
    }

	});

};

document.addEventListener("DOMContentLoaded", ()=>{
	let options = {
		threshold: 0.1
	};

	let observer = new IntersectionObserver(navTrans,options);

	let target = document.querySelector('#hero-section');

	observer.observe(target);
});

function navTrans(entries, observer){

	entries.forEach(entry=> {

		if(entry.isIntersecting){
      document.querySelector('nav').classList.add('transparent');      
    } 

	});
};
};

if ( $(window).width() > 991 ) { 
document.addEventListener("DOMContentLoaded", ()=>{
	let options = {
		threshold: 0.1
	};

	let observer = new IntersectionObserver(navGreenDesktop,options);

	let target = document.querySelector('#what-we-do');

	observer.observe(target);
});

function navGreenDesktop(entries, observer){

	entries.forEach(entry=> {

		if(entry.isIntersecting){
      document.querySelector('nav').classList.remove('transparent');
      document.querySelector('nav').classList.remove('white');
      document.querySelector('nav').classList.add('green');
      
    } else {
      document.querySelector('nav').classList.remove('green');
      document.querySelector('nav').classList.add('white');
    }

	});

};

document.addEventListener("DOMContentLoaded", ()=>{
	let options = {
		threshold: 0.1
	};

	let observer = new IntersectionObserver(navTransDesktop,options);

	let target = document.querySelector('#hero-section');

	observer.observe(target);
});

function navTransDesktop(entries, observer){

	entries.forEach(entry=> {

		if(entry.isIntersecting){
      document.querySelector('nav').classList.add('transparent');
      //document.querySelector('nav').classList.remove('white');
      //document.querySelector('nav').classList.remove('green');
      
    } 

	});

};

// intersection observer #what-we-do animate loading section
document.addEventListener("DOMContentLoaded", ()=>{
	let options = {
		root: null,
		threshold: 0.5
	};
	let observer = new IntersectionObserver(beTouching,options);
	document.querySelectorAll('.what-we-do .panel').forEach(onscreen=>{
		observer.observe(onscreen);
	})
});

function beTouching(entries, observer){

	entries.forEach(entry=> {

		if(entry.isIntersecting){
      entry.target.classList.add('visible');
      console.log('crossed');
      // observer.unobserve(entry.target);
      } 
 
	});

};
};





// accordion open/close arrows
const accordions = document.querySelectorAll('.card-header.accordion-button');

accordions.forEach((accordion) => {
  accordion.addEventListener('click', () => {
    if (accordion.classList.contains('open')) {
      accordion.classList.remove('open');
    } else {
      accordions.forEach((a) => a.classList.remove('open'));
      accordion.classList.add('open');
    }
  });
});



// testimonial slider mobile
if ( jQuery(window).width() < 992 ) { 
    
  const myTimeout = setTimeout(playQoute, 3000);
    
  function playQoute() {
    document.getElementById('hero-logo').style.opacity="0";
    document.getElementById('hero-logo').style.transform="translateX(500px)";
    document.getElementById('hero-logo').style.display="none";
    document.getElementById('hero-testimonial').style.opacity="1";
    document.getElementById('hero-testimonial').style.transform="translateX(0)";
  }
}
    
document.getElementById("menu-menu").addEventListener("click",function(e) {
    document.querySelector('#main-menu').classList.remove('show');
});

//   const navbarLinks = document.querySelectorAll('.navbar-nav a');
// navbarLinks.forEach((link) => {
//   link.addEventListener('click', () => {
//     const elements = document.querySelectorAll('#what-we-do');
//     elements.forEach((element) => {
//       element.scrollLeft -= 50;
//       element.style.transform = 'translateX(-50px)';
//     });
//   });
// });




// const navwhatwedo = document.querySelector('#menu-item-23');
// navwhatwedo.addEventListener('click', () => {
  
//   const elements = document.querySelector('#scrollHorizontal');
  
//   setTimeout(() => {
//     elements.scrollLeft -= 50;
    
//     elements.style.transform = 'translateX(0%)';
//   }, "1000")
  
// });



